import { Path } from "react-router-dom";
import styled from "styled-components";

export const NavContainer = styled.div`
  margin: 0 auto;
  align-items: center;
  @media (max-width: 430px) {
    display: none;
  }
`;
export const Circle = styled.div`
  background-color: #55749f;
  height: 10px;
  width: 10px;
  border-radius: 8px;
`;
export const UlBreadcrumbs = styled.ul`
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  list-style-position: inside;
  list-style-type: none;
`;

export const Alink = styled.a`
  text-decoration: none;
  color: #141414;
  list-style-position: inside;
  margin-left: 5px;
  cursor: pointer;
  &:hover {
    color: #55749f;
  }
`;
